export * from './umpire-component-hero-thematic';
